import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import IconButton from '../IconButton/IconButton.js';

const LineItemDeleteButton = (_param)=>{
    var { className , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "onClick"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(IconButton, {
        onClick: onClick,
        "data-t": rest['data-t'],
        className: classnames('elements-line-item-delete', className),
        "aria-label": getLabel('common.actions.delete')
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "elements-line-item-delete__icon",
        name: "trash"
    }));
};
var LineItemDeleteButton$1 = LineItemDeleteButton;

export { LineItemDeleteButton$1 as default };
//# sourceMappingURL=LineItemDeleteButton.js.map
